var map = {
	"./IMG-20230623-WA0026.jpg": 6206,
	"./IMG-20230623-WA0030.jpg": 8711,
	"./IMG-20230623-WA0031.jpg": 6554,
	"./IMG-20230623-WA0036.jpg": 8649,
	"./IMG-20230623-WA0047.jpg": 7381,
	"./IMG-20230623-WA0072.jpg": 5665,
	"./IMG-20230623-WA0077.jpg": 8944,
	"./IMG-20230623-WA0079.jpg": 5806,
	"./IMG-20230623-WA0081.jpg": 295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6418;